import controller from './widgets-library.controller';
import template from './widgets-library.html';

export default {
    controller,
    template,
    bindings: {
        modalInstance: '<',
        resolve: '<'
    }
};



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/components/widgets-library/widgets-library.component.js